import React, { useEffect, useRef, useState } from "react";
import { LuRefreshCcw } from "react-icons/lu";
import { Tooltip as ReactTooltip } from "react-tooltip";
import BulkExport from "../BulkButton/BulkExport";
import BulkImport from "../BulkButton/BulkImport";
import { FaCheckSquare, FaRegSquare } from "react-icons/fa";
import { IoIosArrowRoundDown } from "react-icons/io";
import { HiDotsVertical, HiOutlineInformationCircle } from "react-icons/hi";
// import { ClipLoader } from "react-spinners";
import { FaCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Container({ children, className = "" }) {
  return (
    <>
      <div className={`p-1 w-full   ${className}`}>{children}</div>
      <div className="mt-5">
        <Pagination />
      </div>
    </>
  );
}

function Title({
  children,
  className = "",
  size = "xl",
  color = "text-gray-500",
  icon = true,
  showExport = true,
  showImport = true,
  message,
}) {
  const [refresh, setRefresh] = useState(null);

  useEffect(() => {
    setRefresh(icon);
  }, [icon, refresh]);

  const textsize = `text-${size}`;
  const content = children
    ?.split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word?.slice(1).toLowerCase())
    .join(" ");

  return (
    <>
      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-2 !py-[2px] !text-white z-20 shadow-md"
      />
      <div className="flex justify-between">
        {/* 1 row */}
        <div className="flex w-full justify-start items-center gap-2">
          <p className={`${textsize} ${color} font-semibold ${className}`}>
            {content}
          </p>
          {refresh && (
            <div
              data-tooltip-id="main-tooltip"
              data-tooltip-content="Refresh"
              className="bg-gray-200 shadow-sm rounded-md cursor-pointer px-1 py-1 justify-center text-center flex items-center"
            >
              <LuRefreshCcw size={18} className="text-gray-500 m-1" />
            </div>
          )}
        </div>

        {/* 2 row */}
        {message ? (
          <div className="flex w-full gap-2 justify-end"></div>
        ) : (
          <div className="flex w-full gap-2 justify-end">
            {showExport && <BulkExport content="Export" />}
            {showImport && <BulkImport content="Import" />}
            <Pagination />
          </div>
        )}
      </div>
    </>
  );
}
function Pagination() {
  const [pageSize, setPageSize] = useState(20);

  const handlePageSize = (value) => {
    setPageSize(Number(value));
  };
  return (
    <div>
      {/* Pagination */}
      <div
        className={`border w-fit border-gray-300 border-collapse rounded text-gray-500 flex items-center opacity-100 group-hover:cursor-pointer`}
      >
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 20 ? "bg-blue-600 text-white rounded" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          20
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 100 ? "bg-blue-600 text-white" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          100
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 500 ? "bg-blue-600 text-white" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          500
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 2500 ? "bg-blue-600 text-white" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          2500
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer ${pageSize === 5000 ? "bg-blue-600 text-white rounded" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          5000
        </div>
      </div>
    </div>
  );
}
function Header({ children, className = "" }) {
  return (
    <div className="w-full rounded-2xl bg-white mt-3 border">{children}</div>
  );
}

function HeaderTitle({ children }) {
  return <div className="w-full flex justify-between">{children}</div>;
}

function HeaderIconLeft({ children }) {
  return <div className="w-full flex p-2 justify-start gap-2">{children}</div>;
}

function HeaderIconRight({ children }) {
  return <div className="w-full flex p-2 justify-end gap-2">{children}</div>;
}

function TableContainer({ children }) {
  return (
    <div className="overflow-y-scroll 2xl:max-w-full  overflow-x-auto  max-h-[550px] border-b relative">
      <table className="min-w-full relative border h-[550px] border-gray-300 border-collapse">
        {children}
      </table>
    </div>
  );
}

function TableHeader({ children = [] }) {
  const [searchText, setSearchText] = useState({});
  const [rotatedColumn, setRotatedColumn] = useState(null);

  const handleClick = (columnName) => {
    setRotatedColumn((prev) => (prev === columnName ? null : columnName));
  };

  const handleChange = (key, value) => {
    setSearchText((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <thead className="sticky top-0 left-0 bg-gray-100 z-10 border border-gray-300 ">
      {/* Title Row */}
      <tr className="bg-gray-100 border  border-gray-300">
        <th className="px-3 py-2 border border-gray-300 whitespace-nowrap w-[40px]">
          <FaCheckSquare className="cursor-pointer text-pink" />
        </th>
        {children.map((title) => (
          <th
            key={title}
            className="px-3 py-2 border border-gray-300 text-center text-sm text-gray-700 font-medium whitespace-nowrap"
          >
            <span className="flex justify-center gap-2 items-center">
              {title}
              {title.toLowerCase() === "status" ? (
                <HiOutlineInformationCircle
                  size={16}
                  className="text-gray-400 cursor-pointer"
                />
              ) : (
                <button
                  onClick={() => handleClick(title)}
                  className={`transform transition-transform duration-300 ${rotatedColumn === title ? "rotate-180" : "rotate-0"
                    }`}
                >
                  <IoIosArrowRoundDown size={20} />
                </button>
              )}
            </span>
          </th>
        ))}
      </tr>

      {/* Search Row */}
      <tr className="bg-gray-100 border border-gray-300">
        <th className="px-3 py-1 border border-gray-300 w-[40px]">
          <FaCheckSquare className="cursor-pointer text-pink" />
        </th>
        {children.map((key) => (
          <th key={key} className="px-2 py-1 border border-gray-300">
            <input
              type="text"
              placeholder="Search"
              value={searchText[key] || ""}
              onChange={(e) => handleChange(key, e.target.value)}
              className="w-full text-sm px-2 py-[4px] bg-white text-gray-700 font-medium rounded-md border border-gray-300 placeholder-gray-400 focus:outline-none"
            />
          </th>
        ))}
      </tr>
    </thead>
  );
}

function TableBody({ rows = [], isLoading = [], error = [], path = [] }) {

  const Nav = useNavigate();
  const [popupRowIndex, setPopupRowIndex] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleDotsClick = (event, index) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    const popupWidth = 150; // Approximate width of the popup
    const popupHeight = 100; // Approximate height of the popup

    // Check screen boundaries
    let left = rect.left;
    let top = rect.bottom;

    if (rect.right + popupWidth > window.innerWidth) {
      left = rect.right - popupWidth; // Shift left if overflowing
    } else {
      left = rect.right;
    }

    if (rect.bottom + popupHeight > window.innerHeight) {
      top = rect.top - popupHeight; // Shift above if bottom overflows
    }

    setPopupPosition({ x: left, y: top });
    setPopupRowIndex(index === popupRowIndex ? null : index);
  };

  const navigate = useNavigate();

  const handleUpdateSeller = async () => {
    navigate("/admin-dashboard/update-seller");
  };

  return (
    <tbody className="text-md text-gray-800 border-gray-300">
      {
        // isLoading ? (
        //   <tr>
        //     <td colSpan="8" className="text-center py-4">
        //       <ClipLoader color="#EF4444" size={35} />
        //     </td>
        //   </tr>
        // ) : error ? (
        //   <tr>
        //     <td colSpan="8" className="text-center py-4 text-red-500">
        //       loading data: {error.message}
        //     </td>
        //   </tr>
        // ) :
        rows?.length === 0 ? (
          <tr>
            <td
              colSpan="8"
              className="text-center py-4 border-gray-300 text-gray-500"
            >
              No matching data found
            </td>
          </tr>
        ) : (
          rows?.map((row, index) => (
            <tr
              key={index}
              className="bg-white text-center border-gray-300 border text-sm hover:bg-gray-100"
            >
              <td className="px-4  border border-gray-300 whitespace-nowrap">
                {/* <FaRegSquare className="cursor-pointer" /> */}
                <input type="checkBox" name="" id="" />
              </td>
              <td
                onClick={() => Nav(path)}
                className="px-4 hover:underline cursor-pointer  border border-gray-300 whitespace-nowrap"
              >
                {row.id}
              </td>
              <td className=" whitespace-nowrap flex items-center justify-center cursor-pointer">
                <div
                  className={`py-1 px-2 flex flex-row w-fit justify-center items-center gap-2 rounded-xl ${row.status === "Suspended"
                    ? "text-gray-500 bg-gray-200"
                    : row.status === "Passive"
                      ? "text-blue-500 bg-blue-200"
                      : row.status === "Premium"
                        ? "text-red-500 bg-red-200"
                        : row.status === "Active"
                          ? "text-green-500 bg-green-200"
                          : "text-orange-500 bg-orange-200"
                    }`}
                >
                  <FaCircle
                    size={10}
                    color={
                      row.status === "Suspended"
                        ? "gray"
                        : row.status === "Passive"
                          ? "blue"
                          : row.status === "Premium"
                            ? "red"
                            : row.status === "Active"
                              ? "green"
                              : "orange"
                    }
                  />{" "}
                  {row.status}
                </div>
              </td>
              <td
                onClick={() => Nav(path)}
                className="px-4 hover:underline cursor-pointer  border border-gray-300 whitespace-nowrap"
              >
                {row.companyName?.slice(0, 20) + "..."}
              </td>
              <td
                onClick={() => Nav(path)}
                className="px-4 hover:underline cursor-pointer   border border-gray-300 whitespace-nowrap"
              >
                {row.email}
              </td>
              <td className="px-4  border border-gray-300 whitespace-nowrap">
                <td className="px-4 py-2 w-full flex m-0 p-0 justify-center ">
                  <div className="flex m-0 p-0 justify-center items-center w-full">
                    <div
                      style={{
                        backgroundImage:
                          'url("https://example.com/path-to-image.jpg")',
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                      className="w-6 h-6 m-0 p-0 rounded-full bg-red-500"
                    ></div>
                    <div className="w-6 h-6 m-0 p-0  rounded-full bg-blue-500"></div>
                    <div className="w-6 h-6 m-0 p-0  rounded-full bg-green-500"></div>
                  </div>
                </td>
              </td>
              <td
                onClick={() => Nav(path)}
                className="px-4 hover:underline cursor-pointer  border border-gray-300 whitespace-nowrap"
              >
                {row.phoneNumber}
              </td>
              <td
                onClick={() => Nav(path)}
                className="px-4 hover:underline cursor-pointer  border border-gray-300 whitespace-nowrap"
              >
                {row.location}
              </td>
              <td
                onClick={() => Nav(path)}
                className="px-4 hover:underline cursor-pointer  border border-gray-300 whitespace-nowrap"
              >
                {row.tags}
              </td>

              {/* Action Column */}
              <td className="px-4 relative  flex justify-center items-center">
                <div onClick={(e) => handleDotsClick(e, index)}>
                  <HiDotsVertical className="cursor-pointer text-center" />
                </div>
                {popupRowIndex === index && (
                  <div
                    style={{
                      position: "fixed",
                      top: popupPosition.y,
                      left: popupPosition.x,
                      zIndex: 50,
                    }}
                    className="bg-white shadow-lg rounded-md p-2 border text-sm"
                  >
                    <div className="hover:bg-gray-100 px-2 py-1 cursor-pointer" onClick={() => Nav(path)}>view</div>
                    <div className="hover:bg-gray-100 px-2 py-1 cursor-pointer" onClick={() => handleUpdateSeller()}>Edit</div>
                    <div
                      onClick={() => {
                        setSelectedRow(row); // or row.id
                        setShowDeleteModal(true);
                        setPopupRowIndex(null); // close the dropdown
                      }}
                      className="hover:bg-red-100 text-red-600 px-3 py-1 cursor-pointer"
                    >
                      Delete
                    </div>

                  </div>
                )}

                {showDeleteModal && (
                  <div className="fixed inset-0 bg-black/10 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-xl text-center max-w-xs w-full">
                      <div className="flex justify-center items-center mb-4">
                        <div className="bg-[#FF0000] rounded-full h-20 flex items-center justify-center w-20">
                          <span className="text-white font-bold text-5xl">?</span>
                        </div>
                      </div>
                      <p className="mb-4 text-gray-800 text-lg font-semibold">
                        Do you want to delete this Buyer?
                      </p>
                      <div className="flex justify-around mt-4">
                        <button
                          className="border border-[#FF0000]  text-[#FF0000]  px-4 py-1 rounded-md text-xl font-bold"
                          onClick={() => setShowDeleteModal(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="bg-[#FF0000]  text-white px-4 py-1 text-xl font-bold rounded-md hover:bg-red-400"
                         onClick={() => setShowDeleteModal(false)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </td>
            </tr>
          ))
        )
      }
    </tbody>
  );
}

export {
  Container,
  Title,
  Header,
  HeaderTitle,
  HeaderIconLeft,
  HeaderIconRight,
  TableContainer,
  TableHeader,
  TableBody,
};
